import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { apiClient } from "src/utils/Api/apiClient";
import { EndUserTypeForDetailedReport } from "../types/EndUserTypeForDetailedReport";


interface endUserForDetailedReportState {
        endUserForDetailedReports: Array<EndUserTypeForDetailedReport>;
        endUserForDetailedReportsLoading: boolean;
        endUserForDetailedReportsError: string | null;
}

const initialState: endUserForDetailedReportState = {
        endUserForDetailedReports: [],
        endUserForDetailedReportsLoading: false,
        endUserForDetailedReportsError: null
}

export const getEndUsersByDealerIDForDetailedReports = createAsyncThunk(
        'endUser/getEndUsersByDealerIDForDetailedReports',
        async (endUserData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`endUser/getEndUsersByDealerIDForDetailedReports/${endUserData}`);
                        return response.data;
                } catch (error: any) {
                        return rejectWithValue(error.message || 'An error occured');
                }
        }
);


const endUserForDetailedReportsSlice = createSlice({
        name: 'endUserForDetailedReports',
        initialState,
        reducers: {
                endUserForDetailedReportsReset: () => initialState,
        },
        extraReducers: (builder) => {
                //get all endUsers from server by dealer id
                builder.addCase(getEndUsersByDealerIDForDetailedReports.pending, (state) => {
                        state.endUserForDetailedReportsLoading = true;
                        state.endUserForDetailedReportsError = null;
                });
                builder.addCase(getEndUsersByDealerIDForDetailedReports.fulfilled, (state, action) => {
                        state.endUserForDetailedReportsLoading = false;
                        state.endUserForDetailedReports = action.payload;
                });
                builder.addCase(getEndUsersByDealerIDForDetailedReports.rejected, (state, action) => {
                        state.endUserForDetailedReportsLoading = false;
                        state.endUserForDetailedReportsError = action.payload as string;
                });

        }
});

export const { endUserForDetailedReportsReset } = endUserForDetailedReportsSlice.actions;
export default endUserForDetailedReportsSlice.reducer;
